import styles from "./home.module.css"
import apartmentsData  from "../../data/apartaments.json"
import {Apartment} from "../../types/apartment.ts"
import { ApartmentCard } from "../apartament/card/ApartmentCard.tsx"
import { AmenitiestCard } from "./amenitiest/AmenitiestCard.jsx"
import { useEffect, useState } from "react"
export const HomePage = () => {
    const [apartments, setApartments] = useState<Apartment[]>([])
    useEffect(()=>{
        setApartments(apartmentsData as Apartment[])
    }, [])
    return (
        <>
        
        <div className="container">
            <main>
                
                <AmenitiestCard/>
                 
                <section className={styles["featured-rooms"]}>
                    <div className={styles["section-title"]}>
                        <h2>Доступные комнаты</h2>
                    </div>
                    <div className={styles["rooms-grid"]}>
                        {apartments.map(room => (
                            <ApartmentCard apartment={room} />
                        ))}
                    </div>
                </section>
            </main>
        </div>
        
        </>
    )
}